import React from "react";
import { Link } from "@hdir/ui/link";
import { Alert } from "@hdir/ui/alert";

import type { EhelsestandardProps } from "./types.d";

import Richtext from "../../../react4xp/shared/Richtext";
import LinkCardWithIcon from "../../../react4xp/shared/LinkCardWithIcon/LinkCardWithIcon";
import ContentFooterMetadata from "/react4xp/shared/ContentFooterMetadata/ContentFooterMetadata";
import SideMenuWithAnchorLinks from "../../../react4xp/shared/SideMenu/Menu/SideMenuWithAnchorLinks";

function ShowEhelsestandard(props: EhelsestandardProps) {
  const {
    data: {
      idStandard,
      korttittel
    },
    sidemenu,
    informasjonStatus,
    normerendeUrl,
    phrases,
    profiler,
    publisher,
    standardStatus,
    standardenGjelderFor,
    tekniskDokumentasjon,
    merknad,
    formalBruksomrade,
    typeStandard,
    tilleggsdokumentasjon,
    footerData
  } = props;

  const footerMetadata = {
    ...footerData,
    usedInContentFooter: false
  };

  return (
    <div>

      {/* Top part of part */}
      <div className="mt-xxl">
        <h1>{korttittel}</h1>
        <div className="flex nt-flex-col tablet:nt-flex-row justify-between mt-sm ">
          <p id="typeStandard" className="text-md">{typeStandard}</p>
          <Link className="text-md" href={normerendeUrl}>{phrases["ehelsestandard.link.explanation"]}</Link>
        </div>
        <div className="flex nt-flex-col tablet:nt-flex-row mt-sm text-sm">
          <p className="mr-sm">
            <strong>ID: </strong>
            {idStandard}
          </p>
          <p>
            <strong>
              {phrases["ehelsestandard.publisher"]}
              :
              {" "}
            </strong>
            {publisher}
          </p>
        </div>
      </div>
      {/* End top part of part */}

      {/* Alert if status is not "Gjeldende" */}
      {
        standardStatus !== "Gjeldende" && (
          <div>
            <Alert className="border-box !w-full mt-xl" variant="info" title={standardStatus}>
              <Richtext text={informasjonStatus} />
            </Alert>
          </div>
        )
      }
      {/* End Alert if status is not "Gjeldende" */}

      {/* Main part of part */}
      <div className="main-content flex nt-flex-col tablet:nt-flex-row mt-xxl gap-xl">
        <div className="basis-1/3 mb-auto tablet:sticky top-4">
          <SideMenuWithAnchorLinks data={sidemenu} />
        </div>
        <div className="flex flex-col border border-solid border-neutral-subtle rounded-sm basis-2/3 p-xl">
          {tekniskDokumentasjon && (
            <div className="flex flex-col">
              <h2 className="mb-lg" id="teknisk-dokumentasjon">{phrases["ehelsestandard.title.technicalDocumentation"]}</h2>
              <div className="flex flex-col gap-sm mb-md">
                {
                  tekniskDokumentasjon?.map((link) => (
                    <div className="w-full">
                      <LinkCardWithIcon link={link} />
                    </div>
                  ))
                }
              </div>
            </div>
          )}

          {formalBruksomrade && (
            <div className="t-body-text mt-xl">
              <h2 className="mb-lg" id="formal-og-bruksomrade">{phrases["ehelsestandard.title.purpose"]}</h2>
              <Richtext text={formalBruksomrade} />
            </div>
          )}

          {profiler && (
            <div className="mt-xl">
              <h2 className="mb-sm" id="profiler">{phrases["ehelsestandard.title.profiles"]}</h2>
              <div className="flex flex-col gap-sm mb-md">
                <p>{phrases["ehelsestandard.preface.profile"]}</p>
                {
                  profiler.map((link) => (
                    <div className="w-full">
                      <LinkCardWithIcon link={link} />
                    </div>
                  ))
                }
              </div>
            </div>
          )}

          {standardenGjelderFor && (
            <div className="t-body-text mt-xl">
              <h2 className="mb-lg" id="standarden-gjelder-for">{phrases["ehelsestandard.title.standardenGjelderFor"]}</h2>
              <Richtext text={standardenGjelderFor} />
            </div>
          )}

          {merknad && (
            <div className="t-body-text mt-xl">
              <h2 className="mb-lg" id="merknad">{phrases["ehelsestandard.title.remark"]}</h2>
              <Richtext text={merknad} />
            </div>
          )}

          {tilleggsdokumentasjon && (
            <div className="mt-xl">
              <h2 className="mb-lg" id="tilleggsdokumentasjon">{phrases["ehelsestandard.title.additionalDocumentation"]}</h2>
              <div className="flex flex-col gap-sm">
                {
                  tilleggsdokumentasjon.map((link) => (
                    <div className="w-full">
                      <LinkCardWithIcon link={link} />
                    </div>
                  ))
                }
              </div>
            </div>
          )}

        </div>
      </div>
      {/* End main part of part */}

      <ContentFooterMetadata data={footerMetadata} />
    </div>
  );
}

export default function(props: EhelsestandardProps) {
  return <ShowEhelsestandard {...props} />;
}
